import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
dayjs.extend(timezone);
dayjs.extend(utc);

/**
 * 将日期转为对应时区时间戳
 * @param time
 * @param tz
 * @returns
 */
export const getTimestampByTimezone = (time: string | number | Date, tz: string): number => {
  return dayjs.tz(time, tz).unix();
};

/**
 * 将日期转为对应时区日期字符串
 * @param time
 * @param tz
 * @param format
 * @returns
 */
export const formatTimestampByTimezone = (time: string | number | Date, tz: string, format?: string) => {
  if (!time) {
    return '';
  }
  let t = Number(time);
  const isGoodNum = t && !isNaN(t);
  if (isGoodNum) {
    if (`${t}`.length === 10) {
      t = parseInt(`${t}`) * 1000;
    }
  }

  return dayjs(t)
    .tz(tz)
    .format(format || 'YYYY-MM-DD HH:mm');
};

/**
 * 将日期转为对应时区日期字符串
 * @param timestamp
 * @param tz
 * @param lang
 * @param pattern
 * @returns
 */

export const formatTimeByTimezone = (
  timestamp: number,
  tz: string,
  lang: string,
  pattern: string = 'MM/DD/YY'
): string => {
  return dayjs(timestamp * 1000)
    .tz(tz)
    .locale(lang)
    .format(pattern);
};
